import { render } from "./ModalVerifyAccount.vue?vue&type=template&id=95d1c160"
import script from "./ModalVerifyAccount.vue?vue&type=script&lang=js"
export * from "./ModalVerifyAccount.vue?vue&type=script&lang=js"

import "./ModalVerifyAccount.vue?vue&type=style&index=0&id=95d1c160&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__